import Button from "@mui/material/Button";

export default function NextLevelButton(props) {
  return (
    <Button
      variant="outlined"
      className="outlined-button outlined-button-blue"
      onClick={() => {
        props.nextLevel();
      }}
    >
      Ďalší level
    </Button>
  );
}
